import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const kiccEasyCardQueries = createQueryKeys('kiccEasyCard', {
    list: () => ({
        queryKey: ['list'],
        queryFn: async () => {
            const res = await KiccEasyCardApi.getCards();
            // pin이 등록되어 있지 않고 카드가 등록되어 있으면 삭제 호출
            if (!res.isPinRegistered && res.cards.length !== 0) {
                for (let i = 0; i < res.cards.length; i += 1) {
                    await KiccEasyCardApi.deleteCard(res.cards[i].cardId);
                }
                return KiccEasyCardApi.getCards();
            }
            return res;
        },
    }),
    bioDevice: (deviceId: string) => ({
        queryKey: [deviceId],
        queryFn: () => KiccEasyCardApi.getIsBioDevice(deviceId),
    }),
});

export default kiccEasyCardQueries;
